/**
 * Mask the gift card number
 * @param {string} cardNumber - gift card number
 * @param {string} mask - mask the gift card should be formatted into
 * @returns {string} an string with masked gift card number
 * @category Utils
 */
export const maskGiftCard = (cardNumber: string, mask = 'X') => mask.repeat(3) + cardNumber.slice(-4)
